import * as Rx from 'rxjs';
import * as RxOp from 'rxjs/operators';
import { getAccessToken, getPosApiUrl } from '../../utils/state';

import { searchAlertBarAction } from '../search/Search.state';
import { lookupAlertBarAction } from '../lookup/Lookup.state';
import {
  FETCH_AGENCIES,
  FETCH_PRODUCTS,
  FETCH_LOOKUP_BY_ID,
  FETCH_SEARCH_BY_ID,
  fetchAgenciesSuccess,
  fetchProductsSuccess,
  fetchLookupByIdSuccess,
  fetchSearchByIdSuccess,
  productsAlertBarAction,
  fetchLookupByIdFailure,
  fetchSearchByIdFailure,
  fetchProductsFailure,
  fetchAgenciesFailure,
} from './Products.state';
import {
  fetchLookupByIdRequest,
  fetchSearchByIdRequest,
  fetchProductsRequest,
  fetchAgenciesRequest,
} from '../../utils/api/client';
import { caughtError } from '../../utils/api/errorHandler';

const caughtFetchLookupErrorCallback = (state) =>
  caughtError(lookupAlertBarAction, 'Search Error:', state);
const caughtFetchSearchErrorCallback = (state) =>
  caughtError(searchAlertBarAction, 'Search Error:', state);

const fetchLookupByIdParams = (state, action) => ({
  url: getPosApiUrl(state),
  token: getAccessToken(state),
  id: action.payload,
});
const fetchSearchByIdParams = (state, action) => ({
  url: getPosApiUrl(state),
  token: getAccessToken(state),
  id: action.payload,
});

export const fetchLookupByIdEpic = (action$, state$) =>
  action$.ofType(FETCH_LOOKUP_BY_ID).pipe(
    RxOp.flatMap((action) =>
      Rx.from(
        fetchLookupByIdRequest(fetchLookupByIdParams(state$.value, action)),
      ).pipe(
        RxOp.flatMap((response) => Rx.of(fetchLookupByIdSuccess(response))),
        RxOp.catchError((err) =>
          caughtFetchLookupErrorCallback(state$.value)(
            err,
            fetchLookupByIdFailure(err.message),
          ),
        ),
      ),
    ),
  );

export const fetchSearchByIdEpic = (action$, state$) =>
  action$.ofType(FETCH_SEARCH_BY_ID).pipe(
    RxOp.flatMap((action) =>
      Rx.from(
        fetchSearchByIdRequest(fetchSearchByIdParams(state$.value, action)),
      ).pipe(
        RxOp.flatMap((response) => Rx.of(fetchSearchByIdSuccess(response))),
        RxOp.catchError((err) =>
          caughtFetchSearchErrorCallback(state$.value)(
            err,
            fetchSearchByIdFailure(err.message),
          ),
        ),
      ),
    ),
  );

const caughtProductsPageErrorCallback = (state) =>
  caughtError(productsAlertBarAction, 'Products Page Error:', state);

const fetchProductsParams = (state) => ({
  url: getPosApiUrl(state),
  token: getAccessToken(state),
});

export const fetchProductsEpic = (action$, state$) =>
  action$.ofType(FETCH_PRODUCTS).pipe(
    RxOp.flatMap(() =>
      Rx.from(fetchProductsRequest(fetchProductsParams(state$.value))).pipe(
        RxOp.flatMap((response) => Rx.of(fetchProductsSuccess(response))),
        RxOp.catchError((err) =>
          caughtProductsPageErrorCallback(state$.value)(
            err,
            fetchProductsFailure(err.message),
          ),
        ),
      ),
    ),
  );

const fetchAgenciesParams = (state) => ({
  url: getPosApiUrl(state),
  token: getAccessToken(state),
});

export const fetchAgenciesEpic = (action$, state$) =>
  action$.ofType(FETCH_AGENCIES).pipe(
    RxOp.flatMap(() =>
      Rx.from(fetchAgenciesRequest(fetchAgenciesParams(state$.value))).pipe(
        RxOp.flatMap((response) => Rx.of(fetchAgenciesSuccess(response))),
        RxOp.catchError((err) =>
          caughtProductsPageErrorCallback(state$.value)(
            err,
            fetchAgenciesFailure(err.message),
          ),
        ),
      ),
    ),
  );
